import { ComponentProps, FC } from 'react'
import { TextArea } from '../../TextArea'
import { FieldInputs } from '../types'
import { FormController } from './FormController'

export const FormTextArea: FC<FieldInputs<string | undefined> & ComponentProps<typeof TextArea>> = (
  props
) => {
  const { name, onValidate, ...rest } = props
  return (
    <FormController
      name={name}
      onValidate={onValidate}
      render={({ value, onValueChange }) => (
        <TextArea onChange={(e) => onValueChange(e.target.value)} value={value} {...rest} />
      )}
    />
  )
}
